// Module
var code = `<template>
  <require from="./instrument-type-info-widget.scss"></require>
  <global-progress if.bind="loading" size="50" stroke-width="5"></global-progress>
  <div if.bind="!loading && !error" class="instrument-type-info-widget instrument-type-info-widget-\${id}" ref="widgetDiv">
    <style>
      .instrument-type-info-widget-\${id} .instrument-type-info-widget__data,
      .instrument-type-info-widget-\${id} .instrument-type-info-widget__data a {
        font-family: \${font || 'var(--dyn-default-font-family)'};
        font-size: \${fontSize ? fontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${color | widgetTemplateColor:isInDashboard} !important;
      }

      .instrument-type-info-widget-\${id} .instrument-type-info-widget__header {
        font-family: \${headerFont ? headerFont : 'var(--dyn-default-font-family)'};
        font-size: \${headerFontSize ? headerFontSize + 'px' : 'var(--dyn-default-font-size)'};
        color: \${headerColor | widgetTemplateColor:isInDashboard} !important;
      }
    </style>

    <div class="instrument-type-info-widget__header">
      <div class="instrument-type-info-widget__header__pl">P/L</div>
      <div class="instrument-type-info-widget__header__value">Value</div>
    </div>
    <div class="instrument-type-info-widget__data" repeat.for="d of data">
      <div class="instrument-type-info-widget__type">
        <a if.bind="isIgnite" href="index.html#/instruments-information?instrumentTypeId=\${d.categoryId}">
          \${d.categoryId | instrumentType}
        </a>
        <span else>\${d.categoryId | instrumentType}</span>
      </div>
      <div class="instrument-type-info-widget__pl">\${d.estimatedProfitLoss | numericFormatter:'0,0'}</div>
      <div class="instrument-type-info-widget__value">\${d.estimatedValue | numericFormatter:'0,0'}</div>
      <div class="instrument-type-info-widget__pl-percent">
        \${d.estimatedProfitLossPercent |numericFormatter:'0,0.0'}%
      </div>
      <div class="instrument-type-info-widget__value-percent">
        \${d.estimatedValuePercent |numericFormatter:'0,0.0'}%
      </div>
    </div>
  </div>

  <message if.bind="error" icon="error" colour="mdc-theme--error" class="instrument-type-info-widget__error">
    \${error.message}</message>
</template>
`;
// Exports
export default code;